document.addEventListener('DOMContentLoaded', () => { 
  const locationDropdown = document.getElementById('location'); 
  const containerDropdown = document.getElementById('container-size'); 
  const resultDisplay = document.getElementById('dynamic-duration'); 
  const priceDisplay = document.getElementById('dynamic-price'); 

  // Define shipping times and pricing 
  const shippingData = { 
    "aqaba-20ft-container": { time: "17 days", price: "£2,893.80" }, 
  "aqaba-40ft-container": { time: "17 days", price: "£2,910.60" }, 
  "aqaba-20ft-container-haz": { time: "17 days", price: "£3,140.20" }, 
"aqaba-40ft-container-haz": { time: "17 days", price: "£3,254.20" }, 
  "benghazi-20ft-container": { time: "20 days", price: "£2,561.40" }, 
  "benghazi-40ft-container": { time: "20 days", price: "£3,222.60" }, 
  "benghazi-20ft-container-haz": { time: "20 days", price: "£2,812.60" }, 
"benghazi-40ft-container-haz": { time: "20 days", price: "£3,507.40" }, 
  "jebel-ali-20ft-container": { time: "34 days", price: "£1,811.40" }, 
  "jebel-ali-40ft-container": { time: "34 days", price: "£1,876.20" }, 
    "jebel-ali-20ft-container-haz": { time: "34 days", price: "£2,132.20" }, 
"jebel-ali-40ft-container-haz": { time: "34 days", price: "£2,197.00" }, 
"sharjar-20ft-container": { time: "36 days", price: "£1,932.60" }, 
  "sharjar-40ft-container": { time: "36 days", price: "£2,170.20" }, 
    "sharjar-20ft-container-haz": { time: "36 days", price: "£2,253.40" }, 
"sharjar-40ft-container-haz": { time: "36 days", price: "£2,491.00" }, 
     "hong-kong-20ft-container": { time: "32 days", price: "£1,003.80" }, 
  "hong-kong-40ft-container": { time: "32 days", price: "£967.80" }, 
    "hong-kong-20ft-container-haz": { time: "32 days", price: "£1,297.00" }, 
"hong-kong-40ft-container-haz": { time: "32 days", price: "£1,249.00" }, 
    "houston-20ft-container": { time: "31 days", price: "£2,968.20" }, 
  "houston-40ft-container": { time: "31 days", price: "£3,399.00" }, 
    "houston-20ft-container-haz": { time: "31 days", price: "£3,273.40" }, 
"houston-40ft-container-haz": { time: "31 days", price: "£3,705.40" }, 
"karachi-port-20ft-container": { time: "32 days", price: "£2,236.20" }, 
  "karachi-port-40ft-container": { time: "32 days", price: "£2,656.20" }, 
    "karachi-port-20ft-container-haz": { time: "32 days", price: "£2,474.20" }, 
"karachi-port-40ft-container-haz": { time: "32 days", price: "£2,879.80" }, 
"jeddah-20ft-container": { time: "31 days", price: "£2,493.00" }, 
  "jeddah-40ft-container": { time: "31 days", price: "£3,049.80" }, 
    "jeddah-20ft-container-haz": { time: "31 days", price: "£2,642.20" }, 
"jeddah-40ft-container-haz": { time: "31 days", price: "£3,403.00" }, 
    "limassol-20ft-container": { time: "33 days", price: "£1,471.00" }, 
  "limassol-40ft-container": { time: "33 days", price: "£1,893.00" }, 
    "limassol-20ft-container-haz": { time: "33 days", price: "£1,749.00" }, 
"limassol-40ft-container-haz": { time: "33 days", price: "£2,011.00" }, 
    "los-angeles-20ft-container": { time: "41 days", price: "£2,837.40" }, 
  "los-angeles-40ft-container": { time: "41 days", price: "£3,238.20" }, 
    "los-angeles-20ft-container-haz": { time: "41 days", price: "£3,143.80" }, 
"los-angeles-40ft-container-haz": { time: "41 days", price: "£3,544.60" }, 
    "mersin-20ft-container": { time: "17 days", price: "£1,487.40" }, 
  "mersin-40ft-container": { time: "17 days", price: "£1,487.40" }, 
    "mersin-20ft-container-haz": { time: "17 days", price: "£1,682.20" }, 
"mersin-40ft-container-haz": { time: "17 days", price: "£1,682.20" }, 
    "misurata-20ft-container": { time: "23 days", price: "£2,401.80" }, 
  "misurata-40ft-container": { time: "23 days", price: "£2,987.40" }, 
    "misurata-20ft-container-haz": { time: "23 days", price: "£2,653.00" }, 
"misurata-40ft-container-haz": { time: "23 days", price: "£3,297.40" }, 
    "mombasa-20ft-container": { time: "41 days", price: "£2,490.60" }, 
  "mombasa-40ft-container": { time: "41 days", price: "£3,294.60" }, 
    "mombasa-20ft-container-haz": { time: "41 days", price: "£2,776.60" }, 
"mombasa-40ft-container-haz": { time: "41 days", price: "£3,580.60" }, 
    "new-york-20ft-container": { time: "20 days", price: "£2,489.60" }, 
  "new-york-40ft-container": { time: "20 days", price: "£2,820.90" }, 
    "new-york-20ft-container-haz": { time: "20 days", price: "£2,617.60" }, 
"new-york-40ft-container-haz": { time: "20 days", price: "£3,039.10" }, 
    "port-everglades-20ft-container": { time: "27 days", price: "£3,699.00" }, 
  "port-everglades-40ft-container": { time: "27 days", price: "£4,081.80" }, 
    "port-everglades-20ft-container-haz": { time: "27 days", price: "£4,163.80" }, 
"port-everglades-40ft-container-haz": { time: "27 days", price: "£4,523.80" }, 
    "port-of-spain-20ft-container": { time: "33 days", price: "£3,015.00" }, 
  "port-of-spain-40ft-container": { time: "33 days", price: "£4,185.00" }, 
    "port-of-spain-20ft-container-haz": { time: "33 days", price: "£3,255.00" }, 
"port-of-spain-40ft-container-haz": { time: "33 days", price: "£4,425.00" }, 
 "port-victoria-20ft-container": { time: "52 days", price: "£3,969.00" }, 
  "port-victoria-40ft-container": { time: "52 days", price: "£6,141.00" }, 
    "port-victoria-20ft-container-haz": { time: "52 days", price: "£4,309.00" }, 
"port-victoria-40ft-container-haz": { time: "52 days", price: "£6,481.00" }, 
"reunion-islands-20ft-container": { time: "25 days", price: "£3,012.60" }, 
  "reunion-islands-40ft-container": { time: "25 days", price: "£4,277.40" }, 
    "reunion-islands-20ft-container-haz": { time: "25 days", price: "£3,457" }, 
"reunion-islands-40ft-container-haz": { time: "25 days", price: "£4,744.60" }, 
     "riyadh-20ft-container": { time: "TBC", price: "£2,656.20" }, 
  "riyadh-40ft-container": { time: "TBC", price: "£3,377.40" }, 
    "riyadh-20ft-container-haz": { time: "TBC", price: "No Haz" }, 
"riyadh-40ft-container-haz": { time: "TBC", price: "No Haz" }, 
"singapore-20ft-container": { time: "34 days", price: "£1,053.00" }, 
  "singapore-40ft-container": { time: "34 days", price: "£1,017.00" }, 
    "singapore-20ft-container-haz": { time: "34 days", price: "£1,346.20" }, 
"singapore-40ft-container-haz": { time: "34 days", price: "£1,298.20" },
"sydney-20ft-container": { time: "40 days", price: "£1,885.80" }, 
  "sydney-40ft-container": { time: "40 days", price: "£2,789.40" }, 
    "sydney-20ft-container-haz": { time: "40 days", price: "£2,386.60" }, 
"sydney-40ft-container-haz": { time: "40 days", price: "£3,443.80" },  
    "toronto-20ft-container": { time: "22 days", price: "£4,506.60" }, 
  "toronto-40ft-container": { time: "22 days", price: "£5,011.80" }, 
    "toronto-20ft-container-haz": { time: "22 days", price: "£4,888.60" }, 
"toronto-40ft-container-haz": { time: "22 days", price: "£5,393.80" }, 
    "tripoli-libya-20ft-container": { time: "23 days", price: "£2,401.80" }, 
  "tripoli-libya-40ft-container": { time: "23 days", price: "£3,023.40" }, 
    "tripoli-libya-20ft-container-haz": { time: "23 days", price: "£2,677.00" }, 
"tripoli-libya-40ft-container-haz": { time: "23 days", price: "£3,302.20" }, 
    "tripoli-lebanon-20ft-container": { time: "20 days", price: "£2,139" }, 
  "tripoli-lebanon-40ft-container": { time: "20 days", price: "£2,593.80" }, 
    "tripoli-lebanon-20ft-container-haz": { time: "20 days", price: "£2,390.20" }, 
"tripoli-lebanon-40ft-container-haz": { time: "20 days", price: "£2,896.60" }, 
    "um-qasr-20ft-container": { time: "32 days", price: "£2,070.60" }, 
  "um-qasr-40ft-container": { time: "32 days", price: "£2,483.40" }, 
    "um-qasr-20ft-container-haz": { time: "32 days", price: "£2,451.40" }, 
"um-qasr-40ft-container-haz": { time: "32 days", price: "£2,804.20" }, 
  }; 
                                         
  const updateResult = () => { 
    const location = locationDropdown.value.toLowerCase().replace(/\s/g, '-'); 
    const container = containerDropdown.value.toLowerCase().replace(/\s/g, '-'); 
    const key = `${location}-${container}`; 
    const data = shippingData[key]; 

    // Update shipping duration 
    resultDisplay.textContent = data ? data.time : "Shipping duration unavailable"; 
    
    // Update pricing (only if the element exists) 
    if (priceDisplay) { 
      priceDisplay.textContent = data ? data.price : "Pricing unavailable"; 
    } 
  }; 
                                         
  locationDropdown.addEventListener('change', updateResult); 
  containerDropdown.addEventListener('change', updateResult); 
}); 